export default {
  'dynamic-bundle:personal-box:message:no-products':
    'In dieser Kategorie gibt es aktuell keine passende Empfehlung für dich',
  'dynamic-bundle:personal-box:message:no-category': 'Kein {category} ausgewählt',
  'dynamic-bundle:personal-box:title:with-pet': `Persönliche Probierbox für {suffix}`,
  'dynamic-bundle:personal-box:title': `Persönliche Probierbox {suffix}`,
  'dynamic-bundle:personal-box:default-title': `Persönliche Probierbox`,
  'dynamic-bundle-controller:for': 'für',
  'dynamic-bundle:personal-box:with': 'mit',
  'dynamic-bundle-controller:with:allergies': 'Zutaten ausschließen',
  'dynamic-bundle-controller:with:preferences': 'Zutaten bevorzugen',
  'dynamic-bundle:usp:personalized:dog': 'Passend zu den Bedürfnissen & Vorlieben deiner Fellnase',
  'dynamic-bundle:usp:personalized:cat': 'Passend zu den Bedürfnissen & Vorlieben deiner Mieze',
  'dynamic-bundle:usp:test-multiple': 'Easy verschiedene Produkte testen',
  'dynamic-bundle:usp:fast-start': 'Schnell starten – null Aufwand für dich',
  'dynamic-bundle:bundle-preview:image-alt': 'Produktbild',
  'dynamic-bundle:button:see-details': 'Details ansehen',
  'dynamic-bundle:button:add-to-cart': 'In den Warenkorb',
  'dynamic-bundle:product:ingredients': 'Zutaten',
  'dynamic-bundle:product:no-content': 'Keine Inhalte verfügbar',
  'dynamic-bundle-controller:price:title': 'Preis deiner Box',
  'dynamic-bundle-controller:button:add-to-cart': 'In den Warenkorb',
  'dynamic-bundle-controller:error:not-enough-products':
    'Du brauchst {min} Produkte, um deine Box zu erstellen',
  'dynamic-bundle-controller:tooltip:warning:max-products-exceeded':
    'Keine weiteren passenden Produkte verfügbar',
  'dynamic-bundle-controller:tooltip:warning:increased': 'Produkt hinzugefügt',
  'dynamic-bundle-controller:tooltip:warning:decreased': 'Produkt entfernt',
  'dynamic-bundle:illustration': 'Illustration eines dynamischen Produktpakets',
  'dynamic-bundle:subscription-overlay:title': 'Jetzt im Spar-Abo: bequem & entspannt',
  'dynamic-bundle:subscription-overlay:benefit:pause-cancel': 'Jederzeit pausieren oder kündigen',
  'dynamic-bundle:subscription-overlay:benefit:flexible-products': 'Produkte flexibel anpassen',
  'dynamic-bundle:subscription-overlay:benefit:discount': '{discount}% Rabatt auf jede Lieferung',
  'dynamic-bundle:subscription-overlay:price:this-delivery': 'Diese Lieferung',
  'dynamic-bundle:subscription-overlay:price:further-deliveries': 'Jede weitere Lieferung',
  'dynamic-bundle:subscription-overlay:price:interval': '(alle {weeks} Wochen)',
  'dynamic-bundle:subscription-overlay:button:subscribe': 'Mit Spar-Abo in den Warenkorb',
  'dynamic-bundle:subscription-overlay:button:one-time': 'Einmalig kaufen',
  'personalised-bundle:headline': 'Noch unsicher? Starte mit deinem personalisierten Probierpaket',
  'personalised-bundle:subline':
    '{count} Rezepturen, perfekt zugeschnitten auf die Bedürfnisse & Vorlieben deines Hundes',
  'personalised-bundle:cta': 'Probierpaket in den Warenkorb',
  'personalised-bundle:image-alt': 'Personalisiertes Probierpaket für deinen Hund',
};
